var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1150"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1150"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34474",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};